var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.57369 16.09L6.24452 12.7566L6.17452 12.6775C6.05025 12.517 5.9888 12.3167 6.00168 12.1142C6.01457 11.9117 6.10092 11.7208 6.24452 11.5775L6.32369 11.5083C6.48412 11.384 6.68439 11.3226 6.88691 11.3354C7.08944 11.3483 7.2803 11.4347 7.42369 11.5783L9.33369 13.4925V3.83412L9.33952 3.73662C9.36321 3.53376 9.46058 3.34666 9.61312 3.21086C9.76567 3.07506 9.96278 3 10.167 2.99995L10.2645 3.00579C10.4674 3.02968 10.6544 3.12725 10.79 3.27995C10.9257 3.43266 11.0005 3.62986 11.0004 3.83412V13.4866L12.9112 11.5783L12.9904 11.5083C13.1579 11.3772 13.3692 11.3151 13.581 11.3348C13.7928 11.3544 13.989 11.4543 14.1296 11.614C14.2701 11.7737 14.3442 11.9811 14.3368 12.1937C14.3293 12.4063 14.2409 12.608 14.0895 12.7575L10.7512 16.0908L10.6729 16.16C10.5124 16.2842 10.3122 16.3457 10.1096 16.3328C9.9071 16.3199 9.71708 16.2336 9.57369 16.09Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownBlack);
export default __webpack_public_path__ + "static/media/ArrowDownBlack.6d4bf2ce3603c0f14c3fa5861da715b3.svg";
export { ForwardRef as ReactComponent };